import { Component } from '@angular/core';
import { Platform, App, NavController } from 'ionic-angular';
import { Subscription } from 'rxjs';
import { AuthenticationService } from '../providers/authentication/authenticationService';
import { NavControllerService } from '../providers/nav-controller/navControllerService';
import { CardReaderLoginPage } from '../pages/card-reader-login/card-reader-login';
import { Storage } from '../../node_modules/@ionic/storage';

@Component({
  templateUrl: 'app.html',
})
export class MyApp {
  rootPage: any = CardReaderLoginPage; //LoginPage; // UsersPage; // CustomerPage;
  private subscription: Subscription;
  private navControllerService: NavControllerService;

  constructor(
    platform: Platform,
    private app: App,
    private authenticationService: AuthenticationService,
    private storage: Storage
  ) {
    this.navControllerService = new NavControllerService(app, storage);
    platform.ready().then(() => {
      // statusBar.styleDefault();
      // $('.svgconvert').svgConvert();
    });
    // Handle HTTP status code 401 "Unauthorized"
    this.subscription = this.authenticationService.requestIntercepted.subscribe((httpResponseStatusCode: number) => {
      if (httpResponseStatusCode == 401) {
        let navCtrl: NavController = this.navControllerService.getActiveNav();
        let activePage = navCtrl.getActive();
        if (activePage.component.name != this.rootPage.name) {
          let currentIndex = navCtrl.getActive().index;
          navCtrl.push(this.rootPage, { isSessionTimeout: true }).then(() => {
            navCtrl.remove(currentIndex);
          });
        }
      }
    });
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts